import * as styles from './styles.css';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useSelector } from 'react-redux';
import { selectFilters } from 'shared/selectors';

import { TBanner } from 'shared/types/banner';

type TColoredBannerProps = TBanner;

export const ColoredBanner: React.FC<TColoredBannerProps> = ({ title, linkBtn, imageClass }) => {
  const device = useDeviceType();

  const { dealType } = useSelector(selectFilters);

  return (
    <div className={clsx(styles['container'], styles[device], dealType && styles[dealType])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['btn']}>
          <LinkButton fullWidth size={device === 'desktop' ? 'L' : 'M'} href={linkBtn.url} target="_blank">
            {linkBtn.text}
          </LinkButton>
        </div>
      </div>
      <div className={clsx(styles['image'], styles[imageClass])} />
    </div>
  );
};
